<script setup>
  import { setupTippyHint } from "~/jose_modern/hint_util";
  import { ref, onMounted } from "vue";

  defineProps({
    caption: { type: String, required: true },
    icon: { type: String, required: true },
  });

  const elem = ref(null);

  onMounted(() => {
    setupTippyHint(elem.value);
  });
</script>

<template>
  <span ref="elem" class="icon" :data-hint="caption">
    <i :class="['fas', icon]"></i>
  </span>
</template>
